import useRadialTreeInteractor from "./radial-tree-interactor-2";
import RadialTreeView from "./radial-tree-view";
import treeData from "../components/data-flare.json";
import "../components/radial-tree.css";

const RadialTreeRunner = () => {
  return <RadialTreeView interactor={useRadialTreeInteractor({ treeData })} />;
};

export default RadialTreeRunner;
